<template>
	<div class="inventory__card inventory__card--info">
		<slideshow :images="images"></slideshow>
		<div class="card__content">
			<div class="card__info">Factory-Certified Nauticstar Dealer</div>
			<div class="map__icon">
				<img src="/images/front/svg/gold-map-pin.svg" alt="map-icon">
			</div>
			<div class="card__title">
				<h2>{{ location?.dealer?.name }}</h2>
			</div>
			<div class="card__phone" v-if="location.phone">
				<a :href="'tel:' + location.phone">{{ location.phone }}</a>
			</div>
			<div class="card__address">
				{{ location.address }}</br>
				{{ location.city }}, {{ location.state }} {{ location.zip }}
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		computed: {
			location() {
				return this.$store.state.location;
			},
			images() {
				if(!this.location || !this.location.gallery) {
					return [];
				}
				return this.location.gallery.map((image) => {
					return image.thumb600;
				});
			}
		}
	}
</script>